<template>
	<div class="oc-map">
		<nav id="filter-menu">
			<div class="clearfix">
				<h4 class="pull-left">Filter Results</h4>
				<a class="pull-right" @click="filterOffside.close()"><i class="fa fa-close fa-2x"></i></a>
			</div>
			<div class="alert bg--error" v-if="showTaxonError" style="margin-top:25px;">
				<div class="alert__body">
					<span>Select a taxon and click on "Apply Filtering" to get started</span>
				</div>
			</div>
			<sighting-filters apiBaseSightings="sighting." @filterChanged="filterChanged" @filtersLoaded="filtersLoaded" :currentUser="current_user"  v-if="current_user_loaded"></sighting-filters>
		</nav>
		<div class="offside-overlay"></div>
		<div :class="mobileNavIn ? 'map-holder mobile-in' : 'map-holder'">
			<button class="btn btn-primary map-nav-mobile-button" @click="mobileNavIn = true">Details &amp; Filters</button>
			<div class="map-nav">
				<button class="map-nav-mobile-off-button btn pull-right" @click="mobileNavIn = false"><i class="fa fa-close fa"></i></button>
				<strong>Map Type</strong>
				<div class="input-select">
					<select v-model="mapType">
						<option value="sighting">Sighting Map</option>
						<option value="sightingGrid">Sighting Grid</option>
						<option value="heatByPercent">Heat Map by Percent</option>
						<option value="heatByCount">Heat Map by Count</option>
						<option value="byCounty">Sightings by County</option>
						<option value="byCountyAndSighting">County + Sightings</option>
					</select>
				</div>
				<strong>Map Background</strong>
				<div class="input-select">
					<select v-model="gMapType">
						<option value="roadmap">Road</option>
						<option value="satellite">Satellite</option>
						<option value="hybrid">Hybrid</option>
						<option value="terrain">Terrain</option>
						<option value="plain">Plain</option>
					</select>
				</div>
				<div class="alert bg--error" v-if="showTaxonError" style="margin-top:25px;">
					<div class="alert__body">
						<span>Select a taxon and click on "Apply Filtering" to get started</span>
					</div>
				</div>
				<button class="btn btn-block btn-primary btn-filter" style="margin-bottom:10px;">Filter Data</button>
				<sighting-filters-summary v-model="filters" v-show="!loading && filter_string != ''"></sighting-filters-summary>
				<div v-show="!loading && (!filters || !filters.excludeDotMap) && showDotMapDisclaimer()" class="label label--inline" style="height:auto;padding: 4px 10px;line-height: normal;">Dot Map data not displayed on this map type.</div>
				<hr v-show="isHeatMap"/>
				<ul v-show="isHeatMap" class="legend_data">
					<li v-for="legend_item in legend_data">
						<div class="color-square" v-bind:style="{ 'background-color': legend_item.color }"></div>
						{{ legend_item.value }}
					</li>
				</ul>
				<div v-show="showCountyLegend() || showSightingLegend()">
					<strong>Legend</strong>
					<div class="sighting-legend" v-show="showSightingLegend()">
						<div class="legend-block"><img :src="this.baseUrl + this.sightingImageUrl" alt=""> Sighting</div>
						<div class="legend-block">
							<img style="margin-bottom:0;" :src="this.baseUrl + this.sightingINatImageUrl" alt=""> iNaturalist Sighting
							<i class="fa fa-info-circle" data-tooltip-wrap data-tooltip='Within 2km of actual location'></i>
						</div>
						<div class="legend-block">
							<img style="margin-bottom:0;" :src="this.baseUrl + this.sightingINatUncertainImageUrl" alt=""> iNaturalist Location Inexact
							<i class="fa fa-info-circle" data-tooltip-wrap data-tooltip='Obscured possibly more than 2km'></i>
						</div>
						<div class="legend-block" v-show="!showCountyLegend()"> <div class="color" style="background-color:#79B1ED"></div> Contains Results (zoom for details)</div>
					</div>
					<div class="county-legend" v-show="showCountyLegend()">
						<div class="legend-block"><div class="color" style="background-color:#FD7D1A"></div> Dot Map Only</div>
						<div class="legend-block"><div class="color" style="background-color:#79B1ED"></div> Submission Only</div>
						<div class="legend-block"><div class="color" style="background-color:#50BB54"></div> Both</div>
					</div>
				</div>

				
				<div class="alert bg--error" v-show="no_results">
					<div class="alert__body">
						<span>No results for selected filters.</span>
					</div>
				</div>
				<div class="alert bg--error" v-show="(mapType == 'sighting' || mapType == 'byCountyAndSighting') && sighting_markers.length >= 20000">
					<div class="alert__body">
						<span>Max of 20,000 results returned.</span>
					</div>
				</div>
				<hr class="hr-small" style="margin:8px 0;">
				<router-link class="btn btn--xs btn-block" :to="{ path: '/data/records/', query: { filterqs: $route.query.filterqs }}"><i class="fa fa-bars"></i> List these results</router-link>
			</div>
			<div class="absolute-holder">
				<Loader extraClass="oc-map-sightings-loader" v-show="loading || sightingsLoading" />
				<GmapMap
				ref="ocMap"
				:center="{lat: 41.850033, lng: -87.6500523}"
				:zoom="5"
				:options="mapOptions"
				:map-type-id="this.gMapType"
				id="ocMap"
				></GmapMap>
			</div>
		</div>
		<sighting-modal uniqueID="mapSightingID" ref="mapSightingModal"></sighting-modal>
	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		name: 'Maps',
		metaInfo: {
		  title: 'Dragonfly & Odonate Species Maps and Range Maps',
		  meta: [
			{ name: "description", content: 'Dragonfly & Odonate Species Maps and Range Maps by taxonomy, location, and more.' },
		  ],
		},
		data: function(){
			return {
				mapType: this.$store.state.mapPreference,
				filters: null,
				filter_string: '',
				heatmap: null,
				sighting_markers: [],
				marker_cluster: null,
				loading: false,
				sightingsLoading:false,
				legend_data: [],
				is_first_load:true,
				no_results:false,
				gMapType:this.$store.state.gmapPreference,
				gridGeoXml: null,
				countyGeoXml: null,
				filterOffside: null,
				filtersAreLoaded: false,
				mapOptions: {
					zoomControl: true,
					mapTypeControl: false,
					scaleControl: false,
					streetViewControl: false,
					rotateControl: false,
					fullscreenControl: false,
				},
				mobileNavIn:false,
				current_user:null,
				current_user_loaded:false,
				zoom_changed:null,
				sightings_bounds:null,
				baseUrl: window.location .protocol + "//" + window.location.host + "/",
				sightingImageUrl: "public/maps/sighting.png",
				sightingINatImageUrl: "public/maps/sighting_inat.png",
				sightingINatUncertainImageUrl: "public/maps/sighting_inat_uncertain.png",
			};
		},
		mounted () {
			var self = this;
			self.GetAPIUser(function(user){
				self.current_user_loaded=true;
				self.current_user = user;
			});

			this.filterOffside = offside( '#filter-menu', {
				buttonsSelector: '.btn-filter',
				slidingSide: 'right', 
			});

			$('.offside-overlay').click(function(){this.filterOffside.close()});

			if (this.filtersAreLoaded && !this.hasTaxon()) {
				this.filterOffside.open()
			}

			this.$refs.ocMap.$mapPromise.then((map) => {
				var moonMapType = new google.maps.ImageMapType({
					getTileUrl: function(a, z) {
						var f = "/public/oc/plain-map-tiles/z"+z+"x"+a.x+"y"+a.y+".png";
						return f;
					},
					tileSize: new google.maps.Size(256, 256),
					maxZoom: 9,
					minZoom: 0,
					name: 'Plain'
				});

				map.mapTypes.set('plain', moonMapType);

				google.maps.event.addListener(map, 'idle', (function () {
					var timer;
					return function() {
						clearTimeout(timer);
						timer = setTimeout(function() {
							if (self.zoom_changed) {
								self.zoom_changed();
							}
						}, 500);
					}
				}()));
			});
			$(window).resize(function(){
				$('#ocMap').css('height', $(window).height() - $('.nav-container').height());
			});
			$(window).resize();
		},
		computed: {
			showTaxonError: function(){
				return !this.hasTaxon();
			},
			isHeatMap:function(){
				return this.mapType.startsWith('heat');
			},
		},
		methods:{
			showDotMapDisclaimer(){
				return !this.mapType.startsWith('byCounty');
			},
			showCountyLegend(){
				return  this.filters && !this.filters.excludeDotMap && this.mapType.startsWith('byCounty');
			},
			showSightingLegend(){
				return this.mapType.toLowerCase().endsWith('sighting');
			},
			getPreviousSightingExists: function(){return false;},
			getNextSightingExists: function(){return false;},
			hasTaxon:function(){
				var ret = this.filters != null && this.filters.selectedTaxons != null && this.filters.selectedTaxons.length > 0;
				return ret;
			},
			filterChanged: function(filters, filter_string, user_action){
				this.filters = JSON.parse(JSON.stringify(filters));
				this.filter_string = filter_string;

				if (this.is_first_load) {
					this.getMap(true);
					this.is_first_load = false;
				}
				else if (this.filterOffside) {
					if (!this.hasTaxon()) {
						this.$notify({
						  text: 'Please select a Taxon to get started.',
						  type: 'error',
						});
						this.filterOffside.open();
					}
					else{
						this.getMap(true);
						this.mobileNavIn = false;
						this.filterOffside.close();
					}
				}
			},
			filtersLoaded:function(){
				this.filtersAreLoaded = true;
				if (!this.hasTaxon() && this.filterOffside) {
					this.filterOffside.open()
				}
			},
			clearSightingsOverlays(){
				if (this.marker_cluster !==null) {
					this.marker_cluster.clearMarkers();
					this.marker_cluster = null;
				}
				for (var i = 0; i < this.sighting_markers.length; i++) {
					this.sighting_markers[i].setMap(null);
				}
				this.sighting_markers = [];
			},
			clearCountyOverlays(){
				if (this.countyGeoXml !== null) {
					this.countyGeoXml.hideDocument();
				}
			},
			clearGridOverlays(){
				if (this.gridGeoXml !== null) {
					this.gridGeoXml.hideDocument();
				}
			},
			clearOverlays:function(){

				if (typeof this.heatmap !== 'undefined' && this.heatmap != null){
					this.heatmap.setMap(null);
					this.heatmap = null;
				}
				this.clearCountyOverlays();
				this.clearGridOverlays();
				this.clearSightingsOverlays();
			},
			clearMap:function(){
				this.clearOverlays();
				this.zoom_changed = null;
			},
			getMap: function(rezoom){
				this.clearMap();
				if (!this.hasTaxon()) {
					return;
				}
				if (this.mapType == 'sighting') {
					this.getSightingMap(rezoom);
					return;
				}
				if (this.mapType == 'heatByPercent') {
					this.getHeatMap(rezoom, 'checklist_percent');
					return;
				}
				if (this.mapType == 'heatByCount') {
					this.getHeatMap(rezoom, 'checklist_count');
					return;
				}
				if (this.mapType == 'byCounty') {
					this.getCountyMap(rezoom);
					return;
				}
				if (this.mapType == 'byCountyAndSighting') {
					this.getSightingMap(rezoom, true);
					this.getCountyMap(true);
					return;
				}
				if (this.mapType == 'sightingGrid') {
					this.getGridMap(rezoom);
					return;
				}


				var listener = google.maps.event.addListener(map, "idle", function() { 
					if (map.getZoom() < 4) map.setZoom(4); 
					google.maps.event.removeListener(listener); 
				});

			},
			showSighting:function(sightingID){
				this.$refs.mapSightingModal.showSighting(sightingID);
			},
			getGridMapFilters:function(){
				if ((this.mapType == 'sighting' || this.mapType == 'sightingGrid') && !this.filters.excludeDotMap) { //grid map needs to exclude dotmap no matter what when it's standing in for sighting dots
					return this.filter_string + "&filter{-sighting.checklist.user.username.in}=Dot_Map_Project";
				}
				return this.filter_string;
			},
			getGridMap:function(rezoom){
				var self = this;
				self.loading = true;
				this.$refs.ocMap.$mapPromise.then((map) => {
					self.API({
						endpoint: 'maps/grid',
						querystring: self.getGridMapFilters() + '&max_results=10000',
						funcThen: function(response){
							var boundaries = [];
							var square;
							self.gridGeoXml = new geoXML3.parser({
							  map: map,
							  zoom: false,
							  suppressInfoWindows: true
							});
							var legendOn = self.showCountyLegend();
							var strkml = `<?xml version="1.0" encoding="utf-8"?>
											<kml xmlns="http://www.opengis.net/kml/2.2">
											  <Document>
												<Style id="normalOnly">
												  <LineStyle>
													<color>50FF7800</color>
													<width>1</width>
												  </LineStyle>
												  <PolyStyle>
													<color>50FF7800</color>
													<colorMode>normal</colorMode>
													<fill>1</fill>
													<outline>1</outline>
												  </PolyStyle>
												</Style>
												<Style id="dotMapOnly">
												  <LineStyle>
													<color>`+ (legendOn ? "641478FF" : "50FF7800") +`</color>
													<width>1</width>
												  </LineStyle>
												  <PolyStyle>
													<color>`+ (legendOn ? "641478FF" : "50FF7800") +`</color>
													<colorMode>normal</colorMode>
													<fill>1</fill>
													<outline>1</outline>
												  </PolyStyle>
												</Style>
												<Style id="normalAndDotMap">
												  <LineStyle>
													<color>`+ (legendOn ? "6414B400" : "50FF7800") +`</color>
													<width>1</width>
												  </LineStyle>
												  <PolyStyle>
													<color>`+ (legendOn ? "6414B400" : "50FF7800") +`</color>
													<colorMode>normal</colorMode>
													<fill>1</fill>
													<outline>1</outline>
												  </PolyStyle>
												</Style>`;

							for (var i = 0; i < response.data.map.length; i++) {
								square = response.data.map[i];
								strkml += "<Placemark>";
								if (square.sightings && square.dot_map) {
									strkml += "<styleUrl>#normalAndDotMap</styleUrl>";
								} else if (square.sightings){
									strkml += "<styleUrl>#normalOnly</styleUrl>";
								}else if (square.dot_map){
									strkml += "<styleUrl>#dotMapOnly</styleUrl>";
								}
								// strkml += "<name>" + square.display_name + "</name>";
								strkml += square.kml;
								strkml += "</Placemark>";
								if (rezoom) {
									boundaries = boundaries.concat(square.boundaries);
								}
							}
							strkml += `</Document>
							</kml>`;
							self.gridGeoXml.parseKmlString(strkml);
							if (rezoom) {
								var latlngbounds = new google.maps.LatLngBounds();
								for (var i = 0; i < boundaries.length; i++) {
									latlngbounds.extend(new google.maps.LatLng(boundaries[i].lat, boundaries[i].lng));
								}
								map.setCenter(latlngbounds.getCenter());
								map.fitBounds(latlngbounds);
							}
							self.loading = false;
						},
					});
				});
			},
			getCountyMap:function(rezoom){
				var self = this;
				self.loading = true;
				this.$refs.ocMap.$mapPromise.then((map) => {
					var kml_results = [];
					axios.all([
						self.API({
							endpoint: 'maps/counties',
							querystring: this.filter_string + '&max_results=10000',
							funcThen: function(response){
								kml_results = kml_results.concat(response.data.map);
							},
						}),
						self.API({
							endpoint: 'maps/grid',
							querystring: this.filter_string + '&filter{-sighting.checklist.location.in}=9&max_results=10000',
							funcThen: function(response){
								kml_results = kml_results.concat(response.data.map);
							},
						})
					]).then(([cr, gr]) => {
						var boundaries = [];
						var result;
						self.countyGeoXml = new geoXML3.parser({
						  map: map,
						  zoom: false,
						  suppressInfoWindows: false
						});
						var strkml = `<?xml version="1.0" encoding="utf-8"?>
										<kml xmlns="http://www.opengis.net/kml/2.2">
										  <Document>
											<Style id="normalOnly">
											  <LineStyle>
												<color>50FF7800</color>
												<width>1</width>
											  </LineStyle>
											  <PolyStyle>
												<color>50FF7800</color>
												<colorMode>normal</colorMode>
												<fill>1</fill>
												<outline>1</outline>
											  </PolyStyle>
											</Style>
											<Style id="dotMapOnly">
											  <LineStyle>
												<color>641478FF</color>
												<width>1</width>
											  </LineStyle>
											  <PolyStyle>
												<color>641478FF</color>
												<colorMode>normal</colorMode>
												<fill>1</fill>
												<outline>1</outline>
											  </PolyStyle>
											</Style>
											<Style id="normalAndDotMap">
											  <LineStyle>
												<color>6414B400</color>
												<width>1</width>
											  </LineStyle>
											  <PolyStyle>
												<color>6414B400</color>
												<colorMode>normal</colorMode>
												<fill>1</fill>
												<outline>1</outline>
											  </PolyStyle>
											</Style>`;
						for (var i = 0; i < kml_results.length; i++) {
							result = kml_results[i];
							strkml += "<Placemark>";
							if (result.sightings && result.dot_map) {
								strkml += "<styleUrl>#normalAndDotMap</styleUrl>";
							} else if (result.sightings){
								strkml += "<styleUrl>#normalOnly</styleUrl>";
							}else if (result.dot_map){
								strkml += "<styleUrl>#dotMapOnly</styleUrl>";
							}
							if (result.display_name) {
								strkml += "<name>" + result.display_name + "</name>";
							}
							else{
								
							}
							strkml += result.kml;
							strkml += "</Placemark>";

							if (rezoom) {
								boundaries = boundaries.concat(result.boundaries);
							}
						}
						strkml += `</Document>
						</kml>`;

						self.countyGeoXml.parseKmlString(strkml);
						if (rezoom) {
							var latlngbounds = new google.maps.LatLngBounds();
							for (var i = 0; i < boundaries.length; i++) {
								latlngbounds.extend(new google.maps.LatLng(boundaries[i].lat, boundaries[i].lng));
							}
							map.setCenter(latlngbounds.getCenter());
							map.fitBounds(latlngbounds);
						}
						self.loading = false;
					});
				});
			},
			getSightingMap:function(rezoom, disable_grid){
				var self = this;
				self.loading = true;
				this.$refs.ocMap.$mapPromise.then((map) => {
					var isfirst = true;
					var currentType = 0;
					self.zoom_changed = function(){
						if (map.zoom < 8) {
							if (currentType != 1) {
								currentType = 1;
								self.clearGridOverlays();
								self.clearSightingsOverlays();
								if (!disable_grid) {
									self.getGridMap(rezoom && isfirst);
									isfirst = false;
								}
							}
						}
						else{
							var new_bounds = map.getBounds();
							var is_contained = false;
							if (self.sightings_bounds !== null) {
								is_contained = self.sightings_bounds.contains(new_bounds.getNorthEast()) && self.sightings_bounds.contains(new_bounds.getSouthWest());
							}
							if (currentType != 2 || !is_contained) {
								currentType = 2;
								self.sightings_bounds = map.getBounds();
								self.sightingsLoading = true;
								var bounds_ne = self.sightings_bounds.getNorthEast();
								var bounds_sw = self.sightings_bounds.getSouthWest();
								var north = bounds_ne.lng();
								var east = bounds_ne.lat();
								var west = bounds_sw.lat();
								var south = bounds_sw.lng();
								var bounds_qs = "&box=" + west+","+north + " " + east+","+north + " " + east+","+south + " " + west+","+south;
								self.API({
									endpoint: 'maps/sightings',
									querystring: this.filter_string + bounds_qs + '&max_results=20000',
									funcThen: function(response){
										self.clearGridOverlays();
										self.clearSightingsOverlays();
										var latlngbounds = new google.maps.LatLngBounds();

										var use_clusters = response.data.map.length > 1000000;

										for (var i = 0; i < response.data.map.length; i++) {
											var s = response.data.map[i];
											var latlng = new google.maps.LatLng(s.latitude, s.longitude);

											var isINat = s.type && s.type == 1;

											var icon = self.sightingImageUrl;
											if (isINat && s.coordinate_uncertainty > 2000) {
												icon = self.sightingINatUncertainImageUrl;
											}
											else if (isINat){
												icon = self.sightingINatImageUrl;
											}

											var marker = new google.maps.Marker({
												position: latlng,
												icon: self.baseUrl + icon,
												sighting_id: s.sighting,
												type: s.type,
												clickable: !isINat
											});

											google.maps.event.addListener(marker, 'click', (function(marker) {
											  return function(evt) {
												if (marker.type != 1) {
													self.showSighting(marker.sighting_id);
												}
											  }
											}(marker)))

											if (!use_clusters) {
												marker.setMap(map);
											}
											self.sighting_markers.push(marker);
										}

										if (use_clusters) {
											var map_area = $('#ocMap').width() * $('#ocMap').height();
											var max_clusters = 100;
											var grid_size = Math.sqrt(map_area/max_clusters);
											if (grid_size < 40) {grid_size = 40;}
											else {grid_size = Math.round(grid_size);}
											if (self.marker_cluster === null) {
												var mc_options = {
													imagePath: self.baseUrl + 'public/maps/m', 
													maxZoom:11, 
													gridSize: grid_size, 
													minimumClusterSize: 15, 
													averageCenter: true,
												}
												self.marker_cluster = new MarkerClusterer(map, [], mc_options);
											}
											self.marker_cluster.addMarkers(self.sighting_markers);
										}

										

										if (response.data.map.length > 0) {
											self.no_results = false;
										}
										else{
											self.no_results = true;
										}
										self.loading = false;
										self.sightingsLoading = false;
									},
								});
							}
						}
					}
					self.zoom_changed();
				});
			},
			getHeatMap:function(rezoom, weight_key){
				var self = this;
				self.loading = true;
				this.$refs.ocMap.$mapPromise.then((map) => {
					this.API({
						endpoint: 'maps/heatmap',
						querystring: this.filter_string,
						funcThen: function(response){
							var heatMapData = [];
							var weights = [];
							var latlngbounds = new google.maps.LatLngBounds();
							var points = [];

							var heat_map_gradient = ["rgba(0, 0, 0, 0)", //first layer is not visible for 0 values
							"#4A4AFF", "#4A49FD", "#4B49FC", "#4C48FB", "#4D48F9", "#4E48F8", "#4F47F7", "#5047F6", "#5147F4", "#5246F3", "#5346F2", "#5445F0", "#5445EF", "#5545EE", "#5644ED", "#5744EB", "#5844EA", "#5943E9", "#5A43E7", "#5B42E6", "#5C42E5", "#5D42E4", "#5E41E2", "#5E41E1", "#5F41E0", "#6040DE", "#6140DD", "#623FDC", "#633FDB", "#643FD9", "#653ED8", "#663ED7", "#673ED5", "#683DD4", "#683DD3", "#693CD2", "#6A3CD0", "#6B3CCF", "#6C3BCE", "#6D3BCD", "#6E3BCB", "#6F3ACA", "#703AC9", "#713AC7", "#7239C6", "#7239C5", "#7338C4", "#7438C2", "#7538C1", "#7637C0", "#7737BE", "#7837BD", "#7936BC", "#7A36BB", "#7B35B9", "#7C35B8", "#7C35B7", "#7D34B5", "#7E34B4", "#7F34B3", "#8033B2", "#8133B0", "#8232AF", "#8332AE", "#8432AC", "#8531AB", "#8631AA", "#8631A9", "#8730A7", "#8830A6", "#892FA5", "#8A2FA4", "#8B2FA2", "#8C2EA1", "#8D2EA0", "#8E2E9E", "#8F2D9D", "#902D9C", "#902C9B", "#912C99", "#922C98", "#932B97", "#942B95", "#952B94", "#962A93", "#972A92", "#982A90", "#99298F", "#9A298E", "#9A288C", "#9B288B", "#9C288A", "#9D2789", "#9E2787", "#9F2786", "#A02685", "#A12683", "#A22582", "#A32581", "#A42580", "#A4247E", "#A5247D", "#A6247C", "#A7237B", "#A82379", "#A92278", "#AA2277", "#AB2275", "#AC2174", "#AD2173", "#AE2172", "#AE2070", "#AF206F", "#B01F6E", "#B11F6C", "#B21F6B", "#B31E6A", "#B41E69", "#B51E67", "#B61D66", "#B71D65", "#B81D63", "#B81C62", "#B91C61", "#BA1B60", "#BB1B5E", "#BC1B5D", "#BD1A5C", "#BE1A5A", "#BF1A59", "#C01958", "#C11957", "#C21855", "#C21854", "#C31853", "#C41752", "#C51750", "#C6174F", "#C7164E", "#C8164C", "#C9154B", "#CA154A", "#CB1549", "#CC1447", "#CC1446", "#CD1445", "#CE1343", "#CF1342", "#D01241", "#D11240", "#D2123E", "#D3113D", "#D4113C", "#D5113A", "#D61039", "#D61038", "#D70F37", "#D80F35", "#D90F34", "#DA0E33", "#DB0E31", "#DC0E30", "#DD0D2F", "#DE0D2E", "#DF0D2C", "#E00C2B", "#E00C2A", "#E10B29", "#E20B27", "#E30B26", "#E40A25", "#E50A23", "#E60A22", "#E70921", "#E80920", "#E9081E", "#EA081D", "#EA081C", "#EB071A", "#EC0719", "#ED0718", "#EE0617", "#EF0615", "#F00514", "#F10513", "#F20511", "#F30410", "#F4040F", "#F4040E", "#F5030C", "#F6030B", "#F7020A", "#F80208", "#F90207", "#FA0106", "#FB0105", "#FC0103", "#FD0002", "#FE0001", "#FF0000"];

							if (weight_key == "checklist_count") {
								for (var i = 0; i < response.data.map.length; i++) {
									var hp = response.data.map[i];
									var loc = new google.maps.LatLng(hp.latitude, hp.longitude);
									latlngbounds.extend(loc);

									var weight = hp[weight_key];
									weights.push(weight);

									points.push({location:loc , weight: weight});
								}

								var get_max_intensity = function(weights){
									var values = weights.concat();

									values.sort( function(a, b) {
										return a - b;
									});

									var q1 = values[Math.floor((values.length / 4))];
									// Likewise for q3. 
									var q3 = values[Math.ceil((values.length * (3 / 4)))];
									var iqr = q3 - q1;

									var maxValue = q3 + iqr*1.5;
									// var minValue = q1 - iqr*1.5;
									return Math.ceil(maxValue);
								};

								var radius = 0.4;
								var max_intensity = get_max_intensity(weights);
							}
							else if (weight_key == "checklist_percent") {
								var max_weight = 0;

								for (var i = 0; i < response.data.map.length; i++) {
									var hp = response.data.map[i];
									var loc = new google.maps.LatLng(hp.latitude, hp.longitude);
									latlngbounds.extend(loc);

									var weight = hp[weight_key];
									points.push({location:loc , weight: weight});
									if (weight > max_weight) {
										max_weight = weight;
									}
								}

								var radius = .8;
								var max_intensity = max_weight;
							}
							else{
								return;
							}
							

							

							if (latlngbounds.getNorthEast().equals(latlngbounds.getSouthWest())) {
								var minExtention = 0.5;
								latlngbounds.extend(new google.maps.LatLng(latlngbounds.getNorthEast().lat() + minExtention, latlngbounds.getNorthEast().lng() + minExtention));
								latlngbounds.extend(new google.maps.LatLng(latlngbounds.getSouthWest().lat() - minExtention, latlngbounds.getSouthWest().lng() - minExtention));
							}

							if (response.data.map.length > 0) {
								if (rezoom) {
									map.setCenter(latlngbounds.getCenter());
									map.fitBounds(latlngbounds);
								}
								self.no_results = false;
							}
							else{
								self.no_results = true;
							}

							for (var i = points.length - 1; i >= 0; i--) {
								if (points[i].weight > max_intensity) {
									points[i].weight = max_intensity;
								}
								heatMapData.push(points[i]);
							}

							self.heatmap = new google.maps.visualization.HeatmapLayer({
								data: heatMapData,
								gradient: heat_map_gradient,
								radius:radius,
								max_intensity: max_intensity,
								opacity: 0.6,
								dissipating: false,
								map: map
							});

							if (isNaN(max_intensity)) {
								max_intensity = 1;
							}

							self.legend_data = [];

							var legend_value_type = ' sightings';
							if (weight_key == "checklist_percent") {
								var legend_value_type = '%';
							}
							self.legend_data.push({
								color: heat_map_gradient[heat_map_gradient.length - 1],
								value: "> " + (max_intensity - 1) + legend_value_type
							});

							self.loading = false;
						}
					});
				});
			},//end getheatmap
		},
		watch: {
			mapType: function () {
				this.getMap(false);
				this.$store.commit('setMapPreference', this.mapType)
			},
			gMapType: function(){
				this.$store.commit('setgMapPreference', this.gMapType)
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/pages/Maps.vue